
 /**
    1-9 万
    11-19 条
    21-29 筒
    
    31-37 东南西北中发白
*/

import data_control from "../../../../../../engines/libs/data_control";
import { ChooseCardKind } from "./ChooseCardKind";

/** 牌型数据区间 */
const CardTypeArea = [
    [1, 9],
    [11,19],
    [21,29],
    [31, 37],
];

const CanUseCardTypeArea = [
    [12, 19]
];

export class ChooseCardDataManage {
    
    /**
     * 根据牌型生成牌数据
     * @param type 
     * @returns 
     */
    static generateCardType(type: number): ChooseCardKind.CardTypeData {
        let TYPE = ChooseCardKind.CardType;
        switch(type) {
            case TYPE.QING_QI_DUI: {
                return this.generateQingQiDui();
            }
            case TYPE.PENG_QING: {
                return this.generatePengQing();
            }
            case TYPE.SHI_SAN_YAO: {
                return this.generateShiSanYao();
            }
        }
    }

    /**
     * 获得牌数据
     * @param count 
     * @param sameNum 
     * @param ownCardData 
     * @returns 
     */
    static getSelectCardData(
        count: number
        , excludeData: number[]
    ) {
        let cardData: number[] = [];
        for (let i = 0; i < count; i++) {
            while(true) {
                let randomV = this.getRandomCard(CanUseCardTypeArea);
                if (!excludeData.includes(randomV) && !cardData.includes(randomV)) {
                    cardData.push(randomV);
                    break;
                }
            }
        }
        return cardData;
    }

    /**
     * 获得牌数据
     * @param count 
     * @param sameNum 
     * @param ownCardData 
     * @returns 
     */
    static getSameCardData(
        count: number
        , sameNum: number
        , ownCardData: number[]
        , areaData: number[][] = null
    ) {
        let cardData: number[] = [];
        for (let i = 0; i < count; i++) {
            while(true) {
                let randomV = this.getRandomCard(areaData);
                if (!ownCardData.includes(randomV)) {
                    for (let j = 0; j < sameNum; j++) {
                        ownCardData.push(randomV);
                    }
                    cardData.push(randomV);
                    break;
                }
            }
        }
        return cardData;
    }

    /**
     * 获得随机牌
     * @returns 
     */
    static getRandomCard(
        areaData: number[][] = null
    ) {
        if (!areaData) {
            areaData = CardTypeArea;
        }
        let len = areaData.length;
        let random = data_control.randomNumInt(0, len-1);
        let cardArea = areaData[random];
        let value = data_control.randomNumInt(cardArea[0], cardArea[1]);
        return value;         
    }

    /**
     * 生成 清七对
     * @returns 
     */
    static generateQingQiDui(): ChooseCardKind.CardTypeData {
        let cardTypeData = new ChooseCardKind.CardTypeData();

        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CanUseCardTypeArea.length-1);
        let cardArea: number[][] = [];
        let cardAreaTmp = cardArea[0] = CanUseCardTypeArea[randomIdx];

        // 1个4张+4对 + 单牌
        this.getSameCardData(6, 2, cardTypeData.card, cardArea);
        let winCard = this.getSameCardData(1, 1, cardTypeData.card, cardArea);
        cardTypeData.winCard = winCard;
        return cardTypeData;
    }

    /**
     * 生成 碰清
     * @returns 
     */
    static generatePengQing(): ChooseCardKind.CardTypeData {
        let cardTypeData = new ChooseCardKind.CardTypeData();
        // 随机花色
        let randomIdx = data_control.randomNumInt(0, CanUseCardTypeArea.length-1);
        let cardArea: number[][] = [];
        let cardAreaTmp = cardArea[0] = CanUseCardTypeArea[randomIdx];

        if (data_control.isHitProbability(0.5)) {
            // 4个3张+单牌
            this.getSameCardData(4, 3, cardTypeData.card, cardArea);
            this.getSameCardData(1, 1, cardTypeData.card, cardArea);
            let winCard = cardTypeData.card[cardTypeData.card.length-1];
            cardTypeData.winCard.push(winCard);
        } else {
            // 3个3张+2对牌
            this.getSameCardData(3, 3, cardTypeData.card, cardArea);
            let winCard = this.getSameCardData(2, 2, cardTypeData.card, cardArea);
            cardTypeData.winCard = winCard;
        }
        return cardTypeData;
    }

    /**
     * 生成 十三幺
     * @returns 
     */
    static generateShiSanYao(): ChooseCardKind.CardTypeData {
        let cardTypeData = new ChooseCardKind.CardTypeData();

        let area = CardTypeArea[3];
        for (let i = area[0]; i <= area[1]; i++) {
            cardTypeData.card.push(i);
        }

        for (let i = 0; i < CardTypeArea.length-1; i++) {
            let o = CardTypeArea[i];
            cardTypeData.card.push(o[0], o[1]);
        }

        cardTypeData.winCard = [CardTypeArea[1][1]]
        return cardTypeData;
    }
    
}